export default __webpack_public_path__ + "static/media/logob.e4e9f9b0.svg";